import { useState } from "react";
import { toast } from "sonner";
import { ShieldX } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";

export const RevokeButton = ({ sessRef, device, label = "Bukan Saya", testid, onDone, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const revoke = async () => {
    setBusy(true);
    try {
      await api.post(`/auth/sessions/${sessRef}/revoke`);
      toast.success("Perangkat telah dikeluarkan dari akun Anda");
      onDone?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      setOpen(false);
    }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} data-testid={testid}
        className={`inline-flex items-center gap-1.5 bg-red-600 hover:bg-red-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors ${className}`}>
        <ShieldX className="h-3.5 w-3.5" /> {label}
      </button>
      <AlertDialog open={open} onOpenChange={(o) => !busy && setOpen(o)}>
        <AlertDialogContent className="max-w-sm" data-testid="revoke-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Keluarkan perangkat ini?</AlertDialogTitle>
            <AlertDialogDescription>
              {device ? <b>{device}</b> : "Perangkat tersebut"} akan langsung dikeluarkan dari akun Anda. Setelah itu, segera ganti PIN di halaman Profil.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={busy} data-testid="revoke-cancel">Batal</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); revoke(); }} disabled={busy} data-testid="revoke-confirm" className="bg-red-600 hover:bg-red-700">
              {busy ? "Memproses..." : "Keluarkan"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
